var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperAdminMenuIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 22,
    height: 23,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M1.58934 21.2711C1.57382 20.021 1.96405 18.7995 2.70149 17.7898C3.66955 16.4645 5.15537 15.6131 6.7883 15.4482L9.41892 15.1824H13.3295L13.312 18.9841C13.3109 19.2244 13.2904 19.4643 13.2507 19.7013C12.9735 21.3559 11.5414 22.5681 9.86367 22.5681H2.80505C2.14013 22.5681 1.59881 22.0334 1.59055 21.3686L1.58934 21.2711Z",
    fill: "#5D5FEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M9.70378 11.0094C12.005 11.0094 13.8704 9.14388 13.8704 6.84269C13.8704 4.54151 12.005 2.67603 9.70378 2.67603C7.40259 2.67603 5.53711 4.54151 5.53711 6.84269C5.53711 9.14388 7.40259 11.0094 9.70378 11.0094Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M12.225 15.176H6.57878C5.47371 15.176 4.4139 15.615 3.6325 16.3964C2.8511 17.1778 2.41211 18.2376 2.41211 19.3427V21.426",
    stroke: "#5D5FEF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M19.579 17.421C20.5427 17.421 21.324 16.6398 21.324 15.676C21.324 14.7123 20.5427 13.931 19.579 13.931C18.6152 13.931 17.834 14.7123 17.834 15.676C17.834 16.6398 18.6152 17.421 19.579 17.421Z",
    stroke: "#5D5FEF",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary svg-fill-white",
    d: "M19.5791 18.801C21.305 18.801 22.7041 17.4019 22.7041 15.676C22.7041 13.9501 21.305 12.551 19.5791 12.551C17.8532 12.551 16.4541 13.9501 16.4541 15.676C16.4541 17.4019 17.8532 18.801 19.5791 18.801Z",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M23.4336 17.1343L22.4961 16.8218",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M16.6621 14.5303L15.7246 14.2178",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M18.1211 19.5303L18.4336 18.5928",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M20.7246 12.7593L21.0371 11.8218",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M21.2459 19.5303L20.9101 18.6482",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M18.2914 12.6905L17.9121 11.8218",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M15.7246 17.3427L16.6547 17.0442",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-primary",
    d: "M22.5469 14.3273L23.4329 14.0093",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperAdminMenuIconFilled);
export default __webpack_public_path__ + "static/media/SuperAdminMenuIconFilled.121261f78b0c52aee6f9a03d7907ebfb.svg";
export { ForwardRef as ReactComponent };